import axios from 'axios';
import { CHANGE_PASSWORD_URL } from 'api/internalToolsUser/constant';
import { createErrorFromAxiosMultipleErrors } from 'api/utilities';

export function performChangePassword(payload) {
  try {
    return axios.post(`${CHANGE_PASSWORD_URL}`, payload).then(response => {
      return Promise.resolve(response);
    });
  } catch (error) {
    throw createErrorFromAxiosMultipleErrors(error);
  }
}
